import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isSelected',
    standalone: false,
    pure: true
})
export class IsSelectedPipe implements PipeTransform {
  transform(item: { id: number }, selectedItems: { id: number }[] | null | undefined): boolean {
    if (!selectedItems || !item) {
      return false;
    }
    return selectedItems.some(s => s.id === item.id);
  }
}
